import type { AnchorResponseModel } from '@/shared/generated'

import { join, pipe, props } from 'lodash/fp'

export const getTableRowId = pipe([
	props(['sales_entity_id', 'sku', 'optimization_group_id']),
	join('__'),
])
export function getAchorTypes(item: AnchorResponseModel) {
	return [
		(item.bundle_anchor_sku || item.bundle_anchor_count) && 'bundle',
		(item.flat_anchor_sku || item.flat_anchor_count) && 'flat',
		(item.ladder_anchor_sku || item.ladder_anchor_count) && 'ladder',
		(item.product_set_anchor_sku || item.product_set_anchor_count) &&
			'product_set',
		(item.size_anchor_sku || item.size_anchor_count) && 'size',
	].filter(Boolean)
}
